import Files from '../../../../../api/Files'
import { RFQApi } from '../../../../../api/Sales/RFQ'
import UploadLines from '../../../../../components/Purchasing/RFQ/Lines/upload/UploadLines'
import moment from 'moment'
import omitEmpty from 'omit-empty'
import React, { Component } from 'react'
import { message, Select } from 'antd'
import { omit, pick } from 'lodash'
import Transactions from '../../../../../api/Finance/Transactions'
import { withRouter } from 'react-router-dom'
import { idMaker } from '../../../../../modules/Utils'
import XLSX from 'xlsx'

const ids = idMaker()
const filesApi = new Files()

class UploadLinesCont extends Component {
  state = {
    transactionUploadList: [],
    selection: [],
    current: 0,
    list: [],
    details: {},
    BankSelectCmp: Select,
    rfq: this.props.rfq,
  }
  fileReader = new FileReader()
  api = new Transactions()
  transactionUploadFormRef = React.createRef()
  mapCsvFields = (list, details) => {
    let rows = []
    const selectedSheet = list.SheetNames[1]
    let XL_row_object = XLSX.utils.sheet_to_json(list.Sheets[selectedSheet])

    const lines = XL_row_object.map((line, i) => {
      let key = ids.next().value

      const d = {
        _key: key,
        _id: key,
        no: line['__EMPTY'],
        rfq: details.rfq,
        ticked: i > 5 && i < XL_row_object.length - 1,
        name: line['__EMPTY_3'],
        description: line['__EMPTY_4'],
        unit: line['__EMPTY_6'],
        uom: { code: line['__EMPTY_7'] },
        type: line['__EMPTY_1'],
      }

      return {
        ...d,
        uploaded: line,
      }
    })
    rows.push(...lines)

    return rows
  }
  checkTransactionUploadForm = () => {
    return new Promise((res) => {
      this.transactionUploadFormRef.current.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.setState({ fetching: true })
            const { transactionUploadList } = this.state
            values.rfq = this.props.rfq
            const list = this.mapCsvFields(transactionUploadList, values)
            this.setState({
              list: list,
              toUploadList: list,
              selection: list.filter((t) => t.ticked).map((t) => t._key),
              details: values,
              fetching: false,
            })
            res(values)
          } catch (e) {
            console.error(e)
            this.setState({ fetching: false })
            message.error(e.errorMessage || 'Error in CSV')
          }
        }
      })
    })
  }
  onShowTransactionUpload = () => {
    this.setState({
      visibleTransactionUpload: true,
    })
  }
  onCancelTransactionUpload = () => {
    this.setState({
      visibleTransactionUpload: false,
      transactionUploadList: [],
      csvFileList: [],
    })
  }
  onFileLoadEnd = async () => {
    try {
      const content = this.fileReader.result
      const transactionUploadList = XLSX.read(content, {
        type: 'binary',
      })
      this.setState({
        transactionUploadList,
      })
    } catch (e) {
      message.error(e.errorMessage || 'Error Converting the XLSX file')
    }
  }
  onFileLoaded = async ({ file }) => {
    try {
      this.fileReader.onloadend = this.onFileLoadEnd
      if (file) {
        await this.fileReader.readAsBinaryString(file)
      }
    } catch (e) {
      message.error('Error Reading the file.')
    }
  }
  beforeUpload = (file) => {
    this.setState({
      csvFileList: [file],
    })
    return false
  }

  prev = () => {
    const current = this.state.current - 1
    this.setState({ current })
  }
  next = async () => {
    let valid = false
    switch (this.state.current) {
      case 0:
        valid = await this.checkTransactionUploadForm()
        break
      default:
        valid = true
    }
    if (valid) {
      const current = this.state.current + 1
      this.setState({ current })
    }
  }

  submit = async () => {
    try {
      this.setState({
        submitting: true,
      })
      let data = this.state.selection.map((s, i) => {
        let line = omit(
          this.state.toUploadList.find((t) => t._key === s),
          ['_id', '_key', 'ticked', 'no']
        )
        line.no = `${('00' + (i + 1)).slice(-2)}`
        line.rfq = pick(line.rfq, ['_id', 'code', 'title'])
        return line
      })

      const formData = new FormData()
      this.state.csvFileList.forEach((file) => {
        formData.append('upload', file)
      })
      const fdata = {
        meta: JSON.stringify(
          omitEmpty({
            folder: `${this.props.rfq._id}`,
            timestamp: moment().utc().format(),
            name: 'Upload CSV File',
            description: 'CSV File Used To Auto Create rfq Liens',
            email: false,
            category: 'rfq',
          })
        ),
      }
      for (let name in fdata) {
        formData.append(name, fdata[name])
      }

      let file = await filesApi.upload(formData)
      await RFQApi.uploadCSV(data)
      this.setState({
        submitting: false,
      })
      message.success('Uploaded!')
      await this.props.fetchLines()
      await this.props.hideModal()
    } catch (e) {
      message.error(e)
      this.setState({
        submitting: false,
      })
    }
  }
  toggleSelection = (key) => {
    let selection = [...this.state.selection]
    const keyIndex = selection.indexOf(key)
    if (keyIndex >= 0) {
      selection = [...selection.slice(0, keyIndex), ...selection.slice(keyIndex + 1)]
    } else {
      selection.push(key)
    }
    this.setState({ selection })
  }
  toggleAll = () => {
    const selectAll = !this.state.selectAll
    const selection = []
    if (selectAll) {
      const wrappedInstance = this.formRef.current.getWrappedInstance()
      const currentRecords = wrappedInstance.getResolvedState().sortedData
      currentRecords.forEach((item) => {
        selection.push(item._original._id)
      })
    }
    this.setState({ selectAll, selection })
  }
  isSelected = (key) => {
    return this.state.selection.includes(key)
  }

  render() {
    return (
      <UploadLines
        {...this.state}
        {...pick(this, [
          'onTransactionUpload',
          'onChangeCompany',
          'checkTransactionUploadForm',
          'onShowTransactionUpload',
          'onCancelTransactionUpload',
          'onFileLoadEnd',
          'onFileLoaded',
          'beforeUpload',
          'transactionUploadFormRef',
          'prev',
          'next',
          'submit',
          'toggleSelection',
          'toggleAll',
          'isSelected',
        ])}
      />
    )
  }
}

UploadLinesCont.propTypes = {}
UploadLinesCont.defaultProps = {}

export default withRouter(UploadLinesCont)
